import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { getOcActionLabel, getOcStatusLabel } from '../../utils/ocRequest';

/**
 * Immutable workflow audit timeline.
 */
const OcWorkflowTimeline = ({ actions = [] }) => {
  if (!actions.length) {
    return <p className="text-muted mb-0">No workflow actions yet.</p>;
  }

  return (
    <ListGroup variant="flush">
      {[...actions]
        .slice()
        .reverse()
        .map(action => (
          <ListGroup.Item key={action.id} className="px-0">
            <div className="fw-semibold">
              {getOcActionLabel(action.action)}
              <span className="text-muted fw-normal ms-2 small">
                {action.created_at
                  ? new Date(action.created_at).toLocaleString()
                  : ''}
              </span>
            </div>
            <div className="small text-muted">
              {getOcStatusLabel(action.from_status)} → {getOcStatusLabel(action.to_status)}
              {action.performed_by_username
                ? ` · ${action.performed_by_username}`
                : action.client_email
                  ? ` · ${action.client_email}`
                  : ''}
            </div>
            {action.comments ? <div className="small mt-1">{action.comments}</div> : null}
          </ListGroup.Item>
        ))}
    </ListGroup>
  );
};

export default OcWorkflowTimeline;
